import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";
import { useBaseData } from "../../../../common/useBaseData";

interface FormValues {
  organizationNumber?: string;
}

interface Props {
  currentValue?: string;
}

export const ChangeOrgNumber = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const baseData = useBaseData();
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      organizationNumber: currentValue,
    },
  });

  if (!baseData) return <div>{t("Loading")}...</div>;

  const newValue = watch("organizationNumber");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ organizationNumber: values.organizationNumber });
      toast({ title: `${t("Organization number has been updated")}!`, status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="organizationNumber" mt="20px" isInvalid={errors.organizationNumber != null}>
        <FormLabel>{t("Organization number")}</FormLabel>
        <Input id={"organizationNumber"} type="text" {...register("organizationNumber", {})} />
        <FormHelperText>{t("Please enter the unique organization number for your company")}.</FormHelperText>
        <FormErrorMessage>{errors.organizationNumber && errors.organizationNumber.message}</FormErrorMessage>
      </FormControl>
      {currentValue?.trim() !== newValue?.trim() && (
        <Button
          mt="10px"
          leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
          variant={"solid"}
          colorScheme="teal"
          size={"sm"}
          isLoading={isSaving}
          type="submit"
        >
          {t("Save change")}
        </Button>
      )}
    </form>
  );
};
